import logo_header from "../../Assets/logo_header.png";
import { IoIosArrowRoundForward } from "react-icons/io";
import * as S from "./Header.styles";

export const Header = () => {

  const handleMenuClick = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <S.Wrapper
      style={{
        zIndex: "999"
      }}
    >
      <S.WrapperContent >
        <img
          src={logo_header}
          alt="logo payquest"
          className="
            w-[151px]
            md:w-[231px]
            "
        />

        <S.MenuWrapper>
          <S.MenuBtn
            onClick={() => handleMenuClick("why-brazil")}
          >
            Why Brazil
          </S.MenuBtn>

          <S.MenuBtn
            onClick={() => handleMenuClick("how-it-works")}
          >
            How it Works
          </S.MenuBtn>

          <S.MenuBtn
            onClick={() => handleMenuClick("industries")}
          >
            Industries
          </S.MenuBtn>

          <S.MenuBtn
            onClick={() => handleMenuClick("compliance")}
          >
            Compliance
          </S.MenuBtn>

          {/* <S.MenuBtn
            onClick={() => handleMenuClick("contact")}
          >
            Contact
          </S.MenuBtn> */}
        </S.MenuWrapper>

        <div
          className="
          flex
          gap-4
          ">
          {/*<S.MenuBtn
            onClick={() =>
              window.open(
                "https://backoffice.payquest.com.br/",
                "_blank"
              )
            }
            className="
          bg-[var(--lime-500)]
          text-[var(--lime-800)]
          hover:bg-[var(--marine-300)]
          hover:text-[var(--lime-500)]
        "
          >
            App Access
            <IoIosArrowRoundForward size={24} />
          </S.MenuBtn>*/}

          {/*<S.MenuBtn
            onClick={() =>
              window.open(
                "https://wa.me/5541999920109?text=Hello%2C%20I%20would%20like%20more%20information.",
                "_blank"
              )
            }
            className="
          bg-[var(--lime-500)]
          text-[var(--lime-800)]
          hover:bg-[var(--marine-300)]
          hover:text-[var(--lime-500)]
        "
          >
            Book a Call
            <IoIosArrowRoundForward size={24} />
          </S.MenuBtn>
          */}
        </div>

      </S.WrapperContent>
    </S.Wrapper>
  );
};
